import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

const initialState={
    shoppingCardList:[],
    shoppingCardSummaryList:[],
    selectedShoppingCard:null,
    selectedShoppingCardSummary:null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchShoppingCards=createAsyncThunk('shoppingCard/fetchShoppingCards',async()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/getAllCards`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchShoppingCardById = createAsyncThunk('shoppingCard/fetchShoppingCardById',async(id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/getCardById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchShoppingCardByVisitorRelID = createAsyncThunk('shoppingCard/fetchShoppingCardByVisitorRelID',async(visitorId)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/getCardByVisitorId/${visitorId}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createShoppingCard = createAsyncThunk('shoppingCard/createShoppingCard',async(shoppingCard)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/createCard`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(shoppingCard)
        }
    )
    return response.json()
})

export const addItemToShoppingCard = createAsyncThunk('shoppingCard/addItemToShoppingCard',async({cardId,itemId,quantity})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/addItem/${cardId}/${itemId}/${quantity}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            //body: JSON.stringify(quantity)
        }
    )
    return response.json()
})

export const removeItemFromShoppingCard = createAsyncThunk('shoppingCard/removeItemFromShoppingCard',async({cardId,itemId})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/removeItem/${cardId}/${itemId}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            //body: JSON.stringify({itemId})
        }
    )
    return response.json()
})

export const deleteShoppingCard = createAsyncThunk('shoppingCard/deleteShoppingCard',async(id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/shoppingcard/deleteCard/${id}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

const shoppingCardSlice = createSlice({
    name:'shoppingCard',
    initialState,
    reducers:{
        changeRegisterStatus:(state)=>{
            state.registerstatus='failure';
        },
        changeEditStatus:(state)=>{
            state.editstatus='failure';
        },
        changeDeleteStatus:(state)=>{
            state.deleteStatus='failure';
        }
    },
    extraReducers:(builder)=>{
        builder
            .addCase(fetchShoppingCards.pending,(state)=>{
                state.status='loading'
            })
            .addCase(fetchShoppingCards.fulfilled,(state,action)=>{
                state.status='succeeded'
                state.shoppingCardList=action.payload
            })
            .addCase(fetchShoppingCards.rejected,(state,action)=>{
                state.status='failed'
                state.error=action.error.message
            })
            .addCase(fetchShoppingCardById.pending,(state)=>{
                state.status='loading'
            })
            .addCase(fetchShoppingCardById.fulfilled,(state,action)=>{
                state.status='succeeded'
                state.selectedShoppingCard=action.payload
            })
            .addCase(fetchShoppingCardById.rejected,(state,action)=>{
                state.status='failed'
                state.error=action.error.message
            })
                .addCase(createShoppingCard.pending,(state)=>{
                    state.registerstatus='loading'
                })
                .addCase(createShoppingCard.fulfilled,(state,action)=>{
                    state.registerstatus='succeeded'
                    state.shoppingCardList.push(action.payload)
                })
                .addCase(createShoppingCard.rejected,(state,action)=>{
                    state.registerstatus='failed'
                    state.error=action.error.message
                })
                .addCase(addItemToShoppingCard.pending,(state)=>{
                    state.editstatus='loading'
                })
                .addCase(addItemToShoppingCard.fulfilled,(state,action)=>{
                    state.editstatus='succeeded'
                    const index = state.shoppingCardList.findIndex(card => card.id === action.payload.id)
                    if(index !== -1){
                        state.shoppingCardList[index] = action.payload
                    }
                })
                .addCase(addItemToShoppingCard.rejected,(state,action)=>{
                    state.editstatus='failed'
                    state.error=action.error.message
                })
                .addCase(removeItemFromShoppingCard.pending,(state)=>{
                    state.editstatus='loading'
                })
                .addCase(removeItemFromShoppingCard.fulfilled,(state,action)=>{
                    state.editstatus='succeeded'
                    const index = state.shoppingCardList.findIndex(card => card.id === action.payload.id)
                    if(index !== -1){
                        state.shoppingCardList[index] = action.payload
                    }
                })
                .addCase(removeItemFromShoppingCard.rejected,(state,action)=>{
                    state.editstatus='failed'
                    state.error=action.error.message
                })
                .addCase(deleteShoppingCard.pending,(state)=>{
                    state.deletestatus='loading'
                })
                .addCase(deleteShoppingCard.fulfilled,(state,action)=>{
                    state.deletestatus='succeeded'
                    state.shoppingCardList=state.shoppingCardList.filter(card => card.id !== action.payload.id)
                })
                .addCase(deleteShoppingCard.rejected,(state,action)=>{
                    state.deletestatus='failed'
                    state.error=action.error.message
                })
            .addCase(fetchShoppingCardByVisitorRelID.pending,(state)=>{
                state.status='loading'
            })
            .addCase(fetchShoppingCardByVisitorRelID.fulfilled,(state,action)=>{
                state.status='succeeded'
                state.selectedShoppingCard=action.payload
            })
            .addCase(fetchShoppingCardByVisitorRelID.rejected,(state,action)=>{
                state.status='failed'
                state.error=action.error.message
            })

    }
})

export default shoppingCardSlice.reducer;